import script from "./LingoDataView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LingoDataView.vue?vue&type=script&lang=ts&setup=true"

import "./LingoDataView.vue?vue&type=style&index=0&id=f56edb4c&scoped=true&lang=css"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f56edb4c"]])

export default __exports__